var map = {
	"./assets/images-offers/acquiring.png": 36014,
	"./assets/images-offers/exception.png": 5746,
	"./assets/images-offers/image1.png": 86411,
	"./assets/images-offers/image2.png": 18885,
	"./assets/images-offers/image3.png": 29094,
	"./assets/images-offers/image4.png": 36282,
	"./assets/images-offers/image6.png": 70823,
	"./assets/images-offers/image7.png": 66686,
	"./assets/images-offers/kyc.svg": 45686,
	"./assets/images-offers/quickDeposit.png": 77833,
	"./assets/images-offers/quickDepositMobile.png": 76242,
	"./assets/images-offers/referralProgram.png": 69741,
	"./assets/images-offers/services.png": 1758,
	"./assets/images-offers/support.png": 62514,
	"./assets/images-offers/welcome.png": 13815,
	"./assets/images/2FAOval.svg": 22709,
	"./assets/images/2faImg.svg": 90691,
	"./assets/images/Cancelled.svg": 36074,
	"./assets/images/CardActiveOvalWhite.svg": 17067,
	"./assets/images/CardFrozenOvalWhite.svg": 17537,
	"./assets/images/CardOvalGray.svg": 8520,
	"./assets/images/CreditCards.svg": 91911,
	"./assets/images/Failed.svg": 35699,
	"./assets/images/Finnished.svg": 73615,
	"./assets/images/PDF-preview.svg": 82328,
	"./assets/images/Pending.svg": 24945,
	"./assets/images/Processing.svg": 66768,
	"./assets/images/Reverted.svg": 82167,
	"./assets/images/TradingDesk.svg": 58679,
	"./assets/images/aboutImgOne.png": 58631,
	"./assets/images/aboutImgTwo.png": 23812,
	"./assets/images/accountProfileMenu.svg": 22171,
	"./assets/images/active-programme.svg": 68395,
	"./assets/images/add-account.svg": 71888,
	"./assets/images/addMoneyOval.svg": 8964,
	"./assets/images/addPerson.svg": 28919,
	"./assets/images/addedPerson.svg": 49362,
	"./assets/images/address.svg": 41302,
	"./assets/images/alert-error.svg": 37515,
	"./assets/images/alert-info.svg": 76706,
	"./assets/images/alert-warning-yellow.svg": 57989,
	"./assets/images/alert-warning.svg": 69978,
	"./assets/images/arrowDown.png": 83630,
	"./assets/images/arrowKeyboardRight.svg": 37558,
	"./assets/images/arrowLeft.svg": 63155,
	"./assets/images/arrowUp.svg": 62880,
	"./assets/images/attachFilesPlus.svg": 16389,
	"./assets/images/availableCards/physicalBlack.png": 79522,
	"./assets/images/availableCards/physicalGoldGTI.png": 67579,
	"./assets/images/availableCards/physicalHills.png": 86018,
	"./assets/images/availableCards/physicalPheonixBlack.png": 93071,
	"./assets/images/availableCards/physicalPhoenixWhite.png": 43438,
	"./assets/images/availableCards/physicalPlatinumGTI.png": 5701,
	"./assets/images/availableCards/physicalStandardGTI.png": 99937,
	"./assets/images/availableCards/virtualBlack.png": 54618,
	"./assets/images/availableCards/virtualDefault.png": 63329,
	"./assets/images/availableCards/virtualFoxpay.png": 19619,
	"./assets/images/availableCards/virtualGTI.png": 39383,
	"./assets/images/availableCards/virtualHills.png": 16712,
	"./assets/images/availableCards/virtualPhoenix.png": 89128,
	"./assets/images/bankAcc.svg": 60200,
	"./assets/images/bankAccountOvalWhite.svg": 41088,
	"./assets/images/bankAccountRoundDarkGrey.svg": 20472,
	"./assets/images/bankAccountRoundGrey.svg": 1116,
	"./assets/images/basketGrey.svg": 51229,
	"./assets/images/blueArrowDown.svg": 45685,
	"./assets/images/blueArrowUp.svg": 99637,
	"./assets/images/business.svg": 52714,
	"./assets/images/businessProfile.svg": 58800,
	"./assets/images/buyAsstesOval.svg": 327,
	"./assets/images/buyCardOval.svg": 61257,
	"./assets/images/calendar.svg": 64589,
	"./assets/images/card.svg": 11010,
	"./assets/images/cardBackCVC.svg": 83266,
	"./assets/images/cardDeactivate.svg": 36882,
	"./assets/images/cardFreeze.svg": 58473,
	"./assets/images/cardHideDetails.svg": 79295,
	"./assets/images/cardHidePin.svg": 32386,
	"./assets/images/cardShowDetails.svg": 23757,
	"./assets/images/cardShowPin.svg": 67990,
	"./assets/images/cardUnfreeze.svg": 91088,
	"./assets/images/check.svg": 38698,
	"./assets/images/check_circle.svg": 8755,
	"./assets/images/checked-grey-circle.svg": 28271,
	"./assets/images/checked-grey-hover.svg": 96715,
	"./assets/images/checked-grey.svg": 64856,
	"./assets/images/close.svg": 79022,
	"./assets/images/closeButton.svg": 30146,
	"./assets/images/commentCloud.svg": 76889,
	"./assets/images/confirmAddress.svg": 51661,
	"./assets/images/contact.png": 13038,
	"./assets/images/contactImgOne.png": 32613,
	"./assets/images/copy-icon.svg": 49606,
	"./assets/images/credit-card-dark-grey.svg": 55634,
	"./assets/images/dashboardLinkIcon.svg": 27950,
	"./assets/images/deactive.svg": 30683,
	"./assets/images/deviceBrowser.svg": 8453,
	"./assets/images/deviceCardsApp.svg": 91733,
	"./assets/images/deviceMobileApp.svg": 1666,
	"./assets/images/document-upload-thumb.svg": 24950,
	"./assets/images/document.svg": 11402,
	"./assets/images/documents.svg": 71117,
	"./assets/images/downloadFileIcon.svg": 88118,
	"./assets/images/downloadOval.svg": 72116,
	"./assets/images/dragndropmark.svg": 35069,
	"./assets/images/dropZoneUpload.svg": 45711,
	"./assets/images/edit.svg": 17285,
	"./assets/images/email-confirm.png": 30235,
	"./assets/images/email2fa.svg": 66497,
	"./assets/images/error-circle.svg": 93151,
	"./assets/images/errors/403.png": 65055,
	"./assets/images/errors/404.png": 76348,
	"./assets/images/errors/503.png": 35640,
	"./assets/images/errors/serverError.svg": 4391,
	"./assets/images/errors/serverOffline.svg": 11866,
	"./assets/images/exchangeOval.svg": 70433,
	"./assets/images/failure-circle.svg": 30472,
	"./assets/images/favourite.svg": 55835,
	"./assets/images/favouriteBordered.svg": 98216,
	"./assets/images/file-icon-oval.svg": 59558,
	"./assets/images/floatingCard.svg": 68597,
	"./assets/images/foxPayCheck.svg": 87467,
	"./assets/images/freeze.svg": 23142,
	"./assets/images/generic.svg": 90508,
	"./assets/images/google-authenticator.svg": 93057,
	"./assets/images/hammer.svg": 57775,
	"./assets/images/hide-pin.svg": 58665,
	"./assets/images/inactive-programme.svg": 41934,
	"./assets/images/lang/ar.svg": 56936,
	"./assets/images/lang/cn.svg": 1679,
	"./assets/images/lang/de.svg": 41710,
	"./assets/images/lang/en.svg": 88944,
	"./assets/images/lang/es.svg": 3587,
	"./assets/images/lang/fr.svg": 39907,
	"./assets/images/lang/in.svg": 62819,
	"./assets/images/lang/it.svg": 88753,
	"./assets/images/lang/lt.svg": 22255,
	"./assets/images/lang/ru.svg": 48043,
	"./assets/images/lang/tr.svg": 49331,
	"./assets/images/ledgers/adaOval.svg": 52961,
	"./assets/images/ledgers/aedOval.svg": 31065,
	"./assets/images/ledgers/air777Oval.svg": 7796,
	"./assets/images/ledgers/atriOval.svg": 84998,
	"./assets/images/ledgers/btcIcon.svg": 47442,
	"./assets/images/ledgers/btcOval.svg": 34916,
	"./assets/images/ledgers/chfOval.svg": 32180,
	"./assets/images/ledgers/cruOval.svg": 76491,
	"./assets/images/ledgers/dogeOval.svg": 70064,
	"./assets/images/ledgers/dwrldOval.svg": 45205,
	"./assets/images/ledgers/eosOval.svg": 55023,
	"./assets/images/ledgers/ethOval.svg": 89080,
	"./assets/images/ledgers/eurOval.svg": 98092,
	"./assets/images/ledgers/ftmOval.svg": 35252,
	"./assets/images/ledgers/gbpOval.svg": 98246,
	"./assets/images/ledgers/gxagOval.svg": 14807,
	"./assets/images/ledgers/lif3Oval.svg": 65332,
	"./assets/images/ledgers/mt760Oval.svg": 62412,
	"./assets/images/ledgers/mt777Oval.svg": 97408,
	"./assets/images/ledgers/paugOval.svg": 27072,
	"./assets/images/ledgers/pauxOval.svg": 37839,
	"./assets/images/ledgers/rlxOval.svg": 4647,
	"./assets/images/ledgers/sgdOval.svg": 92078,
	"./assets/images/ledgers/shibOval.svg": 71892,
	"./assets/images/ledgers/solOval.svg": 84254,
	"./assets/images/ledgers/trxOval.svg": 56118,
	"./assets/images/ledgers/untbOval.svg": 67993,
	"./assets/images/ledgers/usdOval.svg": 55215,
	"./assets/images/ledgers/usdcOval.svg": 83799,
	"./assets/images/ledgers/usdtOval.svg": 31759,
	"./assets/images/ledgers/usduOval.svg": 7106,
	"./assets/images/ledgers/vetOval.svg": 8346,
	"./assets/images/ledgers/wbtcOval.svg": 68705,
	"./assets/images/ledgers/wcruOval.svg": 3510,
	"./assets/images/ledgers/xagOval.svg": 40594,
	"./assets/images/ledgers/xauOval.svg": 66805,
	"./assets/images/ledgers/xptOval.svg": 97959,
	"./assets/images/ledgers/xrpOval.svg": 19949,
	"./assets/images/limitedTokensServices.svg": 59283,
	"./assets/images/linkingAccount.png": 88500,
	"./assets/images/logout.svg": 83412,
	"./assets/images/mastercardLogo.svg": 27821,
	"./assets/images/metalServices.svg": 55569,
	"./assets/images/metals.svg": 77319,
	"./assets/images/navBar.svg": 23224,
	"./assets/images/note.svg": 21185,
	"./assets/images/otherServices.svg": 42007,
	"./assets/images/package.svg": 75778,
	"./assets/images/pencil.svg": 29236,
	"./assets/images/personalProfile.svg": 46545,
	"./assets/images/phone2Fa.svg": 82760,
	"./assets/images/physicalcardOval.svg": 10430,
	"./assets/images/pin-code.svg": 13760,
	"./assets/images/plus-active.svg": 23683,
	"./assets/images/plus-dark-grey.svg": 70508,
	"./assets/images/plus-grey.svg": 62154,
	"./assets/images/plus-white.svg": 43530,
	"./assets/images/priceTag.svg": 23587,
	"./assets/images/printOval.svg": 33989,
	"./assets/images/profile-circle-active.svg": 60467,
	"./assets/images/profile-oval-dark-grey.svg": 81660,
	"./assets/images/profile-oval.svg": 26417,
	"./assets/images/profile.svg": 39010,
	"./assets/images/referral/1.svg": 28159,
	"./assets/images/referral/2.svg": 67879,
	"./assets/images/referral/3.svg": 59664,
	"./assets/images/referral/facebook.svg": 9228,
	"./assets/images/referral/finish.svg": 5137,
	"./assets/images/referral/linkedin.svg": 55387,
	"./assets/images/referral/success.svg": 73767,
	"./assets/images/referral/twitter.svg": 61858,
	"./assets/images/referral/whatsapp.svg": 40402,
	"./assets/images/referralsIcon.svg": 96030,
	"./assets/images/refresh.svg": 77221,
	"./assets/images/refreshGrey.svg": 24255,
	"./assets/images/refund.svg": 14487,
	"./assets/images/security-warn-fab.svg": 56278,
	"./assets/images/selectDropDownArrow.svg": 39692,
	"./assets/images/sellOval.svg": 84913,
	"./assets/images/sepaOval.svg": 9953,
	"./assets/images/servicePlans/cards.svg": 91977,
	"./assets/images/servicePlans/crypto.svg": 8901,
	"./assets/images/servicePlans/ibans.svg": 65237,
	"./assets/images/servicePlans/metals.svg": 23202,
	"./assets/images/servicePlans/plan_bg.png": 54857,
	"./assets/images/servicePlans/stocks.svg": 3063,
	"./assets/images/settingsLinkIcon.svg": 61309,
	"./assets/images/shipping.svg": 74092,
	"./assets/images/sourceOfFunds.svg": 91690,
	"./assets/images/success-circle-gray.svg": 2169,
	"./assets/images/success-circle.svg": 34108,
	"./assets/images/successBig.svg": 98806,
	"./assets/images/support.svg": 5098,
	"./assets/images/supportIconOvalWhite.svg": 89751,
	"./assets/images/swiftOval.svg": 24260,
	"./assets/images/switchAccount.svg": 43197,
	"./assets/images/tooltip-info.svg": 12697,
	"./assets/images/trading-desk-logo.svg": 96788,
	"./assets/images/transactionsLinkIcon.svg": 34527,
	"./assets/images/transfer.svg": 32288,
	"./assets/images/transferOval.svg": 83948,
	"./assets/images/truck-circle.svg": 29765,
	"./assets/images/truck.svg": 93525,
	"./assets/images/ukLocalOval.svg": 50280,
	"./assets/images/unfreeze.svg": 37363,
	"./assets/images/upload-documents.svg": 38746,
	"./assets/images/virtualcardOval.svg": 59884,
	"./assets/images/visaLogo.svg": 87772,
	"./assets/images/visibility-off.svg": 5902,
	"./assets/images/visibility-on.svg": 32334,
	"./assets/images/waiting.svg": 76993,
	"./assets/images/warning-triangle.svg": 35336,
	"./assets/images/warningCloud.svg": 39913,
	"./assets/images/x.svg": 33420,
	"./assets/images/x_hover.svg": 86954,
	"./assets/images/x_red.svg": 40478
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52668;